import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-phone',
  templateUrl: './attr-phone.component.html',
  styleUrls: ['./attr-phone.component.scss'],
  standalone: false,
})
export class AttrPhoneComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: string;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;
  rules: any;

  constructor() {}

  ngOnInit(): void {
    this.rules = { X: /[02-9]/ };
  }
}
